import React, { useEffect, useRef } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

interface Props {
  value: string
  onChange: (content: string) => void
}

const modules = {
  toolbar: [
    [{ header: [] }],
    ['bold', 'italic', 'underline', 'strike', 'clean'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ color: [] }]
  ]
}

export const QuillEditor: React.FC<Props> = ({ value, onChange }) => {
  const editorRef = useRef<ReactQuill>(null)

  const change = (content: string) => {
    if (content === '<p><br></p>' || content === '<p></p>') {
      content = ''
    }
    onChange(content)
  }

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.focus()
    }
  }, [])

  return (
    <ReactQuill
      ref={editorRef}
      theme="snow"
      value={value}
      onChange={change}
      modules={modules}
      className="header-editor"
    />
  )
}
